interface ISetting {
  MAIN_TITLE: string
  TOKEN_KEY: string
  MENU_ROLE: any[]
  OPERATION_MAP: any
}

const setting: ISetting = {
  // 项目名称
  MAIN_TITLE: 'okla',
  // 存放token的属性名称
  TOKEN_KEY: 'planet-token',
  MENU_ROLE: [
    {
      id: 'homePage',
      name: '首页',
      children: [
        {
          id: 'home',
          name: '首页'
        },
        {
          id: 'cmx',
          name: '消费明细',
          children: [
            {
              id: 'cmx1',
              name: '查询'
            }
          ]
        },
        {
          id: 'cye',
          name: '账户余额'
        },
        {
          id: 'ccz',
          name: '充值记录',
          children: [
            {
              id: 'ccz1',
              name: '查询'
            }
          ]
        },
        {
          id: 'cpyl',
          name: '产品一览'
        },
        {
          id: 'comment',
          name: '我的留言',
          children: [
            {
              id: 'comment1',
              name: '查询'
            },
            {
              id: 'comment4',
              name: '删除'
            }
          ]
        }
      ]
    },
    {
      id:'agency',
      name:'代理中心',
      children: [
        {
          id: 'subUser',
          name: '我的客户'
        },
        {
          id: 'settlement',
          name: '佣金结算',
        },
      ]
    },
    {
      id: 'tools',
      name: '号码生成',
      children: [
        {
          id: 'section',
          name: '实时号段生成',
          children: [
            {
              id: 'section1',
              name: '查询'
            },
            {
              id: 'section2',
              name: '下载'
            }
          ]
        },
        {
          id: 'haoma',
          name: '自动号码生成',
          children: [
            {
              id: 'haoma1',
              name: '生成'
            }
          ]
        }
      ]
    },
    {
      id: 'manager',
      name: '用户管理',
      children: [
        {
          id: 'zh',
          name: '账号管理',
          children: [
            {
              id: 'zh1',
              name: '查询'
            },
            {
              id: 'zh2',
              name: '编辑'
            }
          ]
        },
        {
          id: 'ye',
          name: '用户余额',
          children: [
            {
              id: 'ye1',
              name: '查询'
            }
          ]
        },
        {
          id: 'cz',
          name: '充值扣缴',
          children: [
            {
              id: 'cz1',
              name: '查询'
            },
            {
              id: 'cz5',
              name: '充值'
            },
            {
              id: 'cz6',
              name: '删除'
            }
          ]
        },
        {
          id: 'zdcz',
          name: '自动充值订单',
          children: [
            {
              id: 'zdcz1',
              name: '查询'
            },
            {
              id: 'zdcz5',
              name: '添加'
            },
            {
              id: 'zdcz6',
              name: '删除'
            }
          ]
        },
        {
          id: 'czgz',
          name: '自动充值规则',
          children: [
            {
              id: 'czgz1',
              name: '查询'
            },
            {
              id: 'czgz5',
              name: '添加'
            },
            {
              id: 'czgz6',
              name: '删除'
            }
          ]
        },
        {
          id: 'mx',
          name: '消费明细',
          children: [
            {
              id: 'mx1',
              name: '查询'
            }
          ]
        },
        {
          id: 'ma',
          name: '菜单权限',
          children: [
            {
              id: 'ma1',
              name: '查询'
            },
            {
              id: 'ma2',
              name: '编辑'
            }
          ]
        },
        {
          id: 'nr',
          name: '内容管理',
          children: [
            {
              id: 'nr1',
              name: '查询'
            },
            {
              id: 'nr2',
              name: '编辑'
            }
          ]
        },
        {
          id: 'log',
          name: '操作日志',
          children: [
            {
              id: 'log1',
              name: '查询'
            }
          ]
        }
      ]
    },
    // {
    //   id: 'event',
    //   name: '活动专区',
    //   children: [
    //     {
    //       id: 'event1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'event2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'event3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'event4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'black',
    //   name: '盲盒专区',
    //   children: [
    //     {
    //       id: 'black1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'black2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'black3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'black4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'line',
    //   name: 'Line',
    //   children: [
    //     {
    //       id: 'line1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'line2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'line3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'line4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'ws',
    //   name: 'WhatsApp',
    //   children: [
    //     {
    //       id: 'ws1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'ws2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'ws3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'ws4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'tg',
    //   name: 'Telegram',
    //   children: [
    //     {
    //       id: 'tg1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'tg2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'tg3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'tg4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'zalo',
    //   name: 'Zalo',
    //   children: [
    //     {
    //       id: 'zalo1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'zalo2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'zalo3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'zalo4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'linkedin',
    //   name: 'Linkedin',
    //   children: [
    //     {
    //       id: 'linkedin1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'linkedin2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'linkedin3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'linkedin4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'viber',
    //   name: 'Viber',
    //   children: [
    //     {
    //       id: 'viber1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'viber2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'viber3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'viber4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'kakao',
    //   name: 'KakaoTalk',
    //   children: [
    //     {
    //       id: 'kakao1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'kakao2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'kakao3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'kakao4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'snapchat',
    //   name: 'SnapChat',
    //   children: [
    //     {
    //       id: 'snapchat1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'snapchat2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'snapchat3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'snapchat4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'amazon',
    //   name: 'Amazon',
    //   children: [
    //     {
    //       id: 'amazon1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'amazon2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'amazon3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'amazon4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'phone',
    //   name: '设备筛选',
    //   children: [
    //     {
    //       id: 'phone1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'phone2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'phone3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'phone4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'ms',
    //   name: 'Microsoft',
    //   children: [
    //     {
    //       id: 'ms1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'ms2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'ms3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'ms4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'skype',
    //   name: 'Skype',
    //   children: [
    //     {
    //       id: 'skype1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'skype2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'skype3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'skype4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'fb',
    //   name: 'Facebook',
    //   children: [
    //     {
    //       id: 'fb1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'fb2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'fb3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'fb4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'ins',
    //   name: 'Instagram',
    //   children: [
    //     {
    //       id: 'ins1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'ins2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'ins3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'ins4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'tiktok',
    //   name: 'TikTok',
    //   children: [
    //     {
    //       id: 'tiktok1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'tiktok2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'tiktok3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'tiktok4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'twitter',
    //   name: 'Twitter',
    //   children: [
    //     {
    //       id: 'twitter1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'twitter2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'twitter3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'twitter4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'bybit',
    //   name: 'Bybit',
    //   children: [
    //     {
    //       id: 'bybit1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'bybit2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'bybit3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'bybit4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'mint',
    //   name: 'Mint',
    //   children: [
    //     {
    //       id: 'mint1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'mint2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'mint3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'mint4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'gate',
    //   name: 'Gate',
    //   children: [
    //     {
    //       id: 'gate1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'gate2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'gate3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'gate4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'wish',
    //   name: 'Wish',
    //   children: [
    //     {
    //       id: 'wish1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'wish2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'wish3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'wish4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'okx',
    //   name: 'Okx',
    //   children: [
    //     {
    //       id: 'okx1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'okx2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'okx3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'okx4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'htx',
    //   name: 'Htx',
    //   children: [
    //     {
    //       id: 'htx1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'htx2',
    //       name: '编辑'
    //     },
    //     {
    //       id: 'htx3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'htx4',
    //       name: '下载'
    //     }
    //   ]
    // },
    // {
    //   id: 'agent',
    //   name: '成品输出',
    //   children: [
    //     {
    //       id: 'agent1',
    //       name: '查询'
    //     },
    //     {
    //       id: 'agent2',
    //       name: '编辑'
    //     }, 
    //     {
    //       id: 'agent3',
    //       name: '导出'
    //     },
    //     {
    //       id: 'agent4',
    //       name: '下载'
    //     }
    //   ]
    // }
  ],
  OPERATION_MAP: new Map([
    [1, '查询'],
    [2, '编辑'],
    [3, '导出'],
    [4, '下载'],
    [5, '充值'],
    [6, '删除']
  ])
}

export default setting
